import React, {Component} from 'react';
import {Row, Col, Card, Input} from 'antd';
import PropTypes from 'prop-types';
import _ from 'underscore';
import '../css/card.css';

class Card2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataList: props.data,
        };
    }

    /**
     * 搜索
     * @param val
     */
    handleSearch = (val) => {
        console.log(val);
        const {data} = this.props;
        let dataList = [];
        if (val) {
            dataList = _.filter(data, (v) => {
                let vname = v.vname || "", teamname = v.teamname || "", teampositionname = v.teampositionname || "";
                return vname.indexOf(val) >= 0 || teamname.indexOf(val) >= 0 || teampositionname.indexOf(val) >= 0;
            });
        } else {
            dataList = data;
        }
        this.setState({dataList});
    }

    componentWillReceiveProps(nextProps) {
        this.setState({dataList: nextProps.data});
    }

    render() {
        const {title, titleLink, titleLinkClick, style, columns, className} = this.props,
            {dataList} = this.state,
            titleNode = columns.map((col, i) => {
                return (
                    <Col key={i} span={col.span || 2} className="item" style={{padding: '0 20px'}}>{col.name}</Col>
                );
            });
        return (
            <div className={"components-card2 " + className || ""} style={style}>
                <div className="card-head">
                    <div className="i1">{title}</div>
                    <div className="i2 link" onClick={titleLinkClick}>{titleLink}</div>
                </div>
                <Card title={<Row className="card-title">{titleNode}</Row>} bordered
                      bodyStyle={{padding: "20px 10px 10px"}}>
                    <Input.Search
                        placeholder="搜索"
                        onSearch={this.handleSearch}
                        className="search"
                        enterButton
                    />
                    <div className="items">
                        {
                            dataList.length > 0 ? dataList.map((item, index) => {
                                return (
                                    <Row className="item" key={index}>
                                        {
                                            columns.map((col, i) => {
                                                let val = item[col.key || ""];
                                                return (
                                                    <Col key={i} span={col.span} style={{padding: '0 20px'}}>
                                                        {col.render ? col.render(val, item) : (val || col.default)}
                                                    </Col>
                                                );
                                            })
                                        }
                                    </Row>
                                );
                            }) : (<div className="no-data">暂无相关人员</div>)
                        }
                    </div>
                </Card>
            </div>
        );
    }
}

Card2.propTypes = {
    title: PropTypes.string.isRequired,    //头部标题
    titleLink: PropTypes.string.isRequired,    //头部标题右边
    titleLinkClick: PropTypes.func.isRequired,    //头部标题右边点击事件
    data: PropTypes.array.isRequired,    //数据
    columns: PropTypes.array.isRequired,    //列
    style: PropTypes.object,   //自定义样式
    className: PropTypes.string,    //class
}

/**
 * columns 例子：
 * [
 *  {name: "标题名", span: 2, key: "键", render: "自定义方法"}
 * ]
 */

export default Card2;



// WEBPACK FOOTER //
// ./src/components/Card2.jsx